<template>
<div class="flex flex-col dark:bg-slate-800">
    <section class="text-gray-600 body-font">
    <div class="container px-5 py-24 mx-auto flex flex-col dark:bg-slate-800">
        <div class="flex flex-col text-center w-full mb-12">
        <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900  dark:text-gray-200">Log In to Your Account to experience true Fax</h1>
        <p class="lg:w-2/3 mx-auto leading-relaxed text-base dark:text-gray-400">When you log in, we can then get your best fax and then can show your personalized feed</p>
        </div>
        <div class="flex lg:w-2/3 w-full sm:flex-row flex-col mx-auto px-8 sm:space-x-4 sm:space-y-0 space-y-4 sm:px-0 items-end">
            <div class="relative flex-grow w-full">
                <label for="username" class="leading-7 text-sm text-gray-600 dark:text-gray-400">Username</label>
                <input type="text" v-model="username" id="username" name="username" class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-green-200 focus:border-green-500 text-base outline-none text-gray-700 dark:focus:bg-opacity-10 dark:focus:bg-white dark:bg-opacity-0 dark:text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out mt-6">
            </div>
            <div class="relative flex-grow w-full">
                <label for="password" class="leading-7 text-sm text-gray-600 dark:text-gray-400">Password</label>
                <input type="password" v-model="password" id="password" name="password" class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-green-200 focus:border-green-500 text-base outline-none text-gray-700 dark:focus:bg-opacity-10 dark:focus:bg-white dark:bg-opacity-0 dark:text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out mt-6">
            </div>
            <!--<div class="flex flex-col flex-grow w-max">-->
                <div v-if="loginLoading"><img :src="loadingImage" alt=""></div>
                <div v-else class="relative flex-grow w-full sm:w-auto lg:w-auto">
                    <button @click="logMeIn" class="text-white bg-green-500 py-2 px-8 w-fit focus:outline-none hover:bg-green-600 rounded text-lg">Login</button>
                </div>
            <!--</div>-->
            <!--<button @click="snacc('Salud!')" class="text-white bg-green-500 border-0 py-2 px-8 focus:outline-none hover:bg-green-600 rounded text-lg">Snacc Yourself</button>-->
        </div>
        <div class="flex self-center flex-row-reverse w-max mt-9 dark:bg-slate-800">
            <label for="password" class=" text-sm text-gray-600 dark:text-gray-400 ml-3">Remember Me</label>
            <input type="checkbox" v-model="rememberme" value="Remember Me">
        </div>
    </div>
    </section>
    <div class="border border-solid border-green-500 text-xl font-medium rounded-lg bg-white opacity-0 transition-all w-11/12 bottom-3 fixed self-center pt-2 pb-2 hidden dark:bg-opacity-75 dark:text-gray-600" ref="snackbar">
        {{ navMessage }}
    </div>
</div>
<!--
    <input id="usernamefield" type="text" class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-green-200 focus:border-green-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out">
    <input id="passwordfield" type="password" class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-green-200 focus:border-green-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out mt-3">
    <button class="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded mt-3">Log In</button>
-->
</template>

<script>
const devServer = process.env.VUE_APP_PROD_SERVER || "http://localhost:3030" ;
export default {
    name: "LogIn",
    data() {
        return {
            username : "",
            password: "",
            myjwt: {
                token: "",
                username: ""
            },
            authOrNot: false,
            navMessage: "",
            rememberme: false,
            loginLoading: false,
            loadingImage: require('../assets/Rolling-1s-200px.gif'),
        }
    },
    props: {
               pjwt: Object
    },
    methods: {

        snacc: async function(message) {
            this.navMessage = message;
            //console.log("making the opacity to 1....");
            this.$refs.snackbar.style.display = "block";
            this.$refs.snackbar.style.opacity = 1;
            await setTimeout(() => {
                this.$refs.snackbar.style.opacity = 0;
            }, 3000);
            await setTimeout(() => {
                this.$refs.snackbar.style.display = "none";
            }, 3500);
            //console.log("turned the opacity to 0 again....");
        },

        logMeIn : async function() {
            // to emit the username and password to parent
            //console.log("username: ", this.username);
            //console.log(event.target);
            //this.snacc(`${this.rememberme} and type is ${typeof this.rememberme}`)
            //this.snacc("ayo");
            this.loginLoading = true;
            const loginBody = {
                "username": this.username,
                "password": this.password
            }
            let respomse = await fetch(`${devServer}/api/auth/login/`, {
                method: "POST",
                mode: "cors",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(loginBody)
            });
            this.snacc(JSON.stringify(respomse));
            /*
           let respomse = await fetch("https://api.openweathermap.org/data/2.5/weather?lat=28.642&lon=77.0964&appid=729f61068c2d1fb8297f440bd89ef551");
           this.snacc(await respomse.json());
            */
            if(respomse.status == 200) {
                let res = await respomse.json();
                const authString = await res.authorization;
                this.myjwt.token = await authString.split(" ")[1];
                this.myjwt.username = await loginBody.username;
                this.authOrNot = true;
                if(this.rememberme) {
                    this.myjwt = {...this.myjwt, "rememberme": true};
                }
                //console.log(this.myjwt);
                await this.snacc("Log In Success");
                this.$emit("passJWTToParent", this.myjwt);
                this.loginLoading = false;
                this.$router.push(`/feed/${this.myjwt.token}`);
            } else {
                this.loginLoading = false;
                this.snacc("Log In Failed");
            }
            

        }
    }

}
</script>

<style scoped>

</style>
